import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import { Plant } from "interfaces/plant";
import { useTranslation, usePermissions } from "hooks";

import { translations } from "./translations";
interface IGridPlantsProps {
  plants: Plant[] | Record<string, any>[];
}

interface IPlantsProps {
  plant: Plant | Record<string, any>;
}

const Item: React.FC<IPlantsProps> = ({ plant }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission("editPlant");
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/plants/${plant.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{plant.name || "--"}</S.ItemValue>
        <S.ItemValue>{plant.description || "--"}</S.ItemValue>
        <S.ItemValue>{plant.company_code || "--"}</S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridPlants: React.FC<IGridPlantsProps> = ({ plants = [] }) => {
  const { getTranslation } = useTranslation(translations);

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("nome")}</S.Label>
        <S.Label>{getTranslation("descricao")}</S.Label>
        <S.Label>{"Company code"}</S.Label>
      </S.Header>
      {plants.length > 0 &&
        plants.map((plant) => <Item plant={plant} key={plant.id} />)}
    </S.Container>
  );
};
